
// https://github.com/mrdoob/three.js/wiki/Testing-with-npm
import * as THREE from 'three'
import { filmShader } from './three/shader/filmShader.js'

THREE.FilmShader = filmShader

if (window.THREE == undefined)
{
    window.THREE = THREE
}

require('three/examples/js/shaders/CopyShader.js')
require('three/examples/js/postprocessing/EffectComposer.js')
require('three/examples/js/postprocessing/ShaderPass.js')
// require('three/examples/js/shaders/FilmShader.js')
// require('three/examples/js/postprocessing/FilmPass.js')
require('three/examples/js/postprocessing/RenderPass.js')

require('./three/shader/filmPass.js')



export { THREE }
